<template>
  <div id="Detail">
    <Header/>
      <!-- <div class="container"> -->


    <div class="container-fluid">
      <div class="row">

      <div class="col-md-12">
        <div class="image_main" >
          <h2>{{ this.item.name }}</h2>
          <p class="SvgImage"><img v-bind:src="this.item.image" style="display: block; margin: auto;"></p>
        </div>
      </div >

      <div class="col-md-12 center text-break">
        <div class="property">
          <p><b>Address:</b> {{ item.address }} </p>

          <p><b>Balance:</b> {{ item.balance }} ETH</p>

          <div v-if="is_ethereum">
            <p style="padding: 10px">
              <input class="col-75" type="text" id="value" name="value" placeholder="ETH" required size="18" v-model="txtInput" @keyup.enter="deposit2">
              <button class="col-25 btn btn-warning" v-on:click="deposit2($event, item.address)" >Feed</button>
            </p></br>
            <div v-if="item.owner=='null'">
              <p style="padding-top: 10px">
                <p class="col-75"><b>Price:</b> 0.02 ETH</p>
                <button class="col-25 btn btn-warning" v-on:click="buy2($event, item.address)" >BUY</button>
              </p>
            </div>
            <div v-else>
              <p><b>Token Owner:</b> {{ item.owner }}</p>
            </div>
          </div>

          <!-- <b>Parent:</b>
          <div class="col-sm-4 col-md-3 col-lg-3 text-break primary" style="text-align:center">
            <div class="item rounded">
              <p><b>{{ parent.name }}</b></p>
              <div class="image" >
                <router-link :to="{name: 'Detail', query: {id: parent.index}}">
                  <p class="SvgImage"><img v-bind:src="parent.image" style="display: block; margin: auto;"></p>
                </router-link>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>


    <div class="container-fluid list">

      <div class="row all-display">
        <b>Parent:</b>
        <div class="col-sm-4 col-md-2 col-lg-2 text-break primary" >
          <div class="item rounded">
            <p><b>{{ parent.name }}</b></p>
            <div class="image" >
              <router-link :to="{name: 'Detail', query: {id: parent.index}}">
                <p class="SvgImage"><img v-bind:src="parent.image" style="display: block; margin: auto;"></p>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="row all-display"  v-if="children.length > 0">
        <b>Children:</b>
        <div class="col-sm-4 col-md-2 col-lg-2 text-break primary" v-for="(item_, index) in children" :key="index" style="vertical-align: baseline;">
          <router-link class="item-list":to="{name: 'Detail', query: {id: item_.index}}">
          <div class="item rounded">
            <p><b>{{ item_.name }}</b></p>
            <div class="image" >
                <p class="SvgImage"><img v-bind:src="item_.image" style="display: block; margin: auto;"></p>
            </div>
            <div v-if="item_.owner=='null'">
              <p class="price"><b>Price:</b> 0.02 ETH</p>
              <!-- <button class="btn btn-list btn-warning" v-on:click="buy2($event, item.address)" v-if="is_ethereum" >BUY NOW</button> -->
            </div>
          </div>
          </router-link>
        </div>
      </div>
    </div>
      <!-- </div> -->
    <Footer/>
  </div>
</template>

<script>
import Header from "./Header.vue"
import Footer from "./Footer.vue"
import Web3Util from "../web3_util.js"
import db from "../firebase.js"

export default {
  name: 'detail',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      id: 1,
      item: [],
      children: [],
      parent: "",
      is_ethereum: false,
      txtInput: "",
    }
  },
  created () {
    this.id = this.$route.query.id;
    this.initialize();
  },

  methods:{
    // clickCallback: function (pageNum) {
    //    this.currentPage = Number(pageNum);
    // },
    deposit2: function (event, address) {
      console.log(address)
      Web3Util.deposit(address, this.txtInput);//133238529999900
      // if (event) {
      //   alert(event.target.tagName)
      // }
    },
    buy2: function (event, address) {
      console.log(address)
      Web3Util.buy(address, this.txtInput);
    },

    async initialize(){
      this.children = []
      this.item = ""
      this.parent = ""
      if (this.is_ethereum){
        let accounts = await ethereum.request({ method: 'eth_accounts' });
      }
      // this.address = web3.utils.toChecksumAddress(accounts[0])

      // console.log(this.address)

      await db.collection("info")
        .where("index", "==", parseInt(this.id))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data().image}`)
            this.item = doc.data()
          })
        })

      db.collection("info")
        .where("parent", "==", String(this.id))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data().image}`)
            this.children.push(doc.data())
          })
        })

      db.collection("info")
        .where("index", "==", parseInt(this.item.parent))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data().image}`)
            this.parent = doc.data()
          })
        })
      this.is_ethereum = await Web3Util.load();
    }
  },

  watch: {
    $route(to, from) {
      window.scrollTo(0, 100);
      this.id = this.$route.query.id;
      this.initialize();
    }
  },

  mounted: async function () {
    window.scrollTo(0, 100);
    // window.history.go()
    this.id = this.$route.query.id;
    // let accounts = await ethereum.request({ method: 'eth_accounts' });
    // this.initialize();
  },

}

</script>

<style>

h2 {
  margin-bottom: 60px;
}

.label {
  /* margin: 0px 5px; */
  padding: 10px;
  text-align: left;
}

.list{
  padding: 100px;
}

.h2 {
  padding: 100px;
}

.property {
  text-align: left;
  padding: 10px;
}

.center {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: left;
  text-align: left;
}

.item {
  padding: 10px 15px;
  border: 1px solid #000000;
  border-color: rgb(200,200,200,.7);
  /* height: 300px; */
  /* width: 100%; */
  height: 100%;
}

.image {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
}

.image_parent {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
}

.image_main {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 100px;
}

.all-display .col-md-3 {
  padding: 50px 10px;
  text-align: left;
}

.SvgImage img{
  height: auto;
  max-height: 250px;
  max-width: 100%;
  width:100%;
}

/* Floating column for labels: 25% width */
.col-25 {
  float: left;
  width: 25%;
  /* margin-top: 6px; */
}

/* Floating column for inputs: 75% width */
.col-75 {
  float: left;
  width: 70%;
  margin-top: 6px;
  margin-right: 10px;
}






#list {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 40px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.all-display .col-md-3 {
  padding: 10px 10px;
  text-align: left;
}

.all-display .col-md-2 {
  padding: 10px 10px;
  text-align: left;
}

.all-display {
  margin: 0px 5px;
  text-align: left;
}

.item {
  padding: 10px 15px;
  border: 1px solid #000000;
  border-color: rgb(200,200,200,.7);
  /* height: 300px; */
  /* width: 100%; */
  /* height: auto; */
}

.image {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  height: 250px;
}

.SvgImage img{
  height: auto;
  max-height: 250px;
  max-width: 100%;
  width:100%;
}

.mylife {
  text-align: center;
  padding: 10% 10%;
}

@media screen and(max-width: 600px) {
  .text {
    padding: 10% 15%;
    font-size: 10px;
  }
}

.text {
  padding: 150px 10%;
  font-size: 24px
}

.btn{
  font-weight: bold;
  color: white;
}

.btn-list{
  font-weight: bold;
  font-size: 10px;
  color: white;
  padding: 0;
}

a.item-list{
  color: black;
  text-decoration: none;
}

p.price{
  font-size: 14px;
  padding: 0;
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Detail.vue